import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';
import { Specialty } from './specialty.model';
import { specialties } from './specialty.mock';

@Injectable({
  providedIn: 'root'
})
export class EoSpecialtyDropdownService {
  specialties$ = new BehaviorSubject<Specialty[]>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  getSpecialties(url: string): Observable<Specialty[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.specialties$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<Specialty[]>(param);
  }

  getSpecialtiesMock(): Observable<Specialty[]> {
    this.status$.next(STATUS.loading);
    const obs$ = new Observable<Specialty[]>((sub) => {
      setTimeout(() => {
        sub.next(specialties);
        this.specialties$.next(specialties);
        this.status$.next(STATUS.success);
      }, 1000);
    });

    return obs$;
  }
}
